import React from "react";
import { MdSearchOff } from "react-icons/md";
import { colors, spacing } from "../library/theme";
import { css } from "glamor";

const container = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: spacing.m,
  textAlign: "center",
  width: "100%",
});
const icon = {
  color: colors.primaryDarker,
  marginBottom: spacing.s,
};
const title = {
  marginBottom: spacing.xxs,
};

export default function QuestionSearchEmpty() {
  return (
    <div className={container}>
      <MdSearchOff size={64} style={icon} />
      <h4 style={title}>Sem resultados</h4>
      <span>Tente com outros termos</span>
    </div>
  );
}
